// extracted by mini-css-extract-plugin
export default {"parrafo":"estilo_parrafo__EqQ7D"};